import { ReactNode } from "react";

import { PollingIntervalGroups } from "apollo/constants";
import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import DesktopView from "components/Mobile/DesktopView";
import MobileView from "components/Mobile/MobileView";
import ViewHeader from "components/ViewHeader";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import TabWithCounter from "ds/components/Tab/WithCounter";
import useOpenTofuMigrationCounts from "shared/Stack/OpenTofuMigration/useCounts";

import {
  OPEN_TOFU_MIGRATION_DASHBOARD_PATH,
  OPEN_TOFU_MIGRATION_PATH,
  OPEN_TOFU_MIGRATION_QUEUE_PATH,
  OPEN_TOFU_MIGRATION_TITLE,
} from "./constants";

type OpenTofuMigrationViewHeaderProps = {
  children: ReactNode;
};

const OpenTofuMigrationViewHeader = ({ children }: OpenTofuMigrationViewHeaderProps) => {
  const { eligibleToMigrate, queueEntries } = useOpenTofuMigrationCounts(
    PollingIntervalGroups.Lists
  );

  useBreadcrumbs([
    { title: "Dashboard", link: OPEN_TOFU_MIGRATION_DASHBOARD_PATH },
    { title: OPEN_TOFU_MIGRATION_TITLE },
  ]);

  return (
    <ViewHeader>
      <ViewHeaderWrapper direction="row" justify="between" fullWidth>
        <ViewHeaderWrapper direction="row" align="center">
          <ViewHeaderTitle>{OPEN_TOFU_MIGRATION_TITLE}</ViewHeaderTitle>
          <MobileView>{children}</MobileView>
        </ViewHeaderWrapper>

        <DesktopView>
          <ViewHeaderWrapper direction="row" align="end" shrink="0">
            {children}
          </ViewHeaderWrapper>
        </DesktopView>
      </ViewHeaderWrapper>

      <ViewHeaderNavigation>
        <TabWithCounter
          end
          to={OPEN_TOFU_MIGRATION_PATH}
          count={eligibleToMigrate}
          label="Ready to migrate"
        />
        <TabWithCounter to={OPEN_TOFU_MIGRATION_QUEUE_PATH} count={queueEntries} label="Queue" />
      </ViewHeaderNavigation>
    </ViewHeader>
  );
};

export default OpenTofuMigrationViewHeader;
